import { Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { Component } from '@angular/core';
import { SuscriptionService } from '@core/services';
import { Suscription } from '@shared/models';
import { dayOfTheWeek, groupBy } from '@shared/utils';

@Component({
  selector: 'app-suscriptions-list',
  templateUrl: './suscriptions-list.page.html',
  styleUrls: ['./suscriptions-list.page.scss'],
})
export class SuscriptionsListPage {
  private refreshSubject = new Subject<void>();
  suscriptions$: Observable<Suscription[]> = this.refreshSubject.asObservable().pipe(
    switchMap(() => this.getSuscriptions()),
    tap((suscriptions) => {
      if (suscriptions?.length) {
        this.selectSuscriptionSubject.next(suscriptions[0]);
      }
    })
  );
  private selectSuscriptionSubject = new Subject<Suscription>();
  selectedSuscription$: Observable<Suscription> = this.selectSuscriptionSubject.asObservable();
  dailies$: Observable<{ name: string; dailies: { dotw: string; stop: string; departureTime: string }[] }[]> =
    this.selectedSuscription$.pipe(map((suscription) => this.generateDailies(suscription)));

  constructor(private suscriptionService: SuscriptionService) {}

  ionViewDidEnter() {
    this.refreshSubject.next();
  }

  private getSuscriptions(): Observable<Suscription[]> {
    return this.suscriptionService.getSuscriptions().pipe(catchError(() => of([])));
  }

  selectSuscription(suscription: Suscription) {
    this.selectSuscriptionSubject.next(suscription);
  }

  generateDailies(suscription: Suscription) {
    const suscription_dailies = groupBy(suscription.suscription_dailies, (daily) => daily.type);
    return Object.keys(suscription_dailies).map((key) => {
      const dailies = suscription_dailies[key];
      const mappedDailies = dailies.map((daily) => {
        return { dotw: dayOfTheWeek(daily.dotw), stop: daily.stop_name, departureTime: daily.departure_time };
      });
      const name = key === 'go' ? 'Llegada' : 'Salida';
      return { name, dailies: mappedDailies };
    });
  }
}
